/*
 * 用户管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'user',
  name: 'BusinessUser',
  component: EmptyRouterAlive,
  meta: {
    title: '用户管理',
  },
  children: [
    /**     ****** 用户管理    ******** */
    {
      path: 'account',
      name: 'BusinessUserAccount',
      component: EmptyRouter,
      redirect: 'account/list',
      meta: { title: '账户管理', isCache: true },
      children: [
        {
          path: 'list',
          name: 'BusinessUserAccount',
          component: () => import('@/views/center-business/user/account/index'),
          meta: { title: '账户管理', isCache: true },
        },
        {
          path: 'add',
          name: 'BusinessUserAccountAdd',
          component: () => import('@/views/center-business/user/account/add'),
          meta: { title: '新建账户', isCache: true },
          hidden: true,
        },
        {
          path: 'edit',
          name: 'BusinessUserAccountEdit',
          component: () => import('@/views/center-business/user/account/edit'),
          meta: { title: '编辑账户' },
          hidden: true,
        },
        {
          path: 'custom',
          name: 'BusinessUserAccountCustom',
          component: () => import('@/views/center-business/user/account/custom'),
          meta: { title: '新建客户', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_RelatedCompany',
          meta: { title: '关联组织架构' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_ChangePassword',
          meta: { title: '修改密码' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_UseStatus',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_Locked',
          meta: { title: '锁定/解锁' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_Delete',
          meta: { title: '删除账户' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_Log',
          meta: { title: '日志' },
          hidden: true,
        },
      ],
    },
    {
      path: 'account',
      name: 'BusinessUserAccountCSG',
      component: EmptyRouter,
      redirect: 'account/listCSG',
      meta: { title: '账户管理', isCache: true },
      children: [
        {
          path: 'listCSG',
          name: 'BusinessUserAccountCSG',
          component: () => import('@/views/center-business/user/account/listCSG'),
          meta: { title: '账户管理', isCache: true },
        },
        {
          path: 'addCSG',
          name: 'BusinessUserAccountAddCSG',
          component: () => import('@/views/center-business/user/account/addCSG'),
          meta: { title: '新建账户', isCache: true },
          hidden: true,
        },
        {
          path: 'editCSG',
          name: 'BusinessUserAccountEditCSG',
          component: () => import('@/views/center-business/user/account/editCSG'),
          meta: { title: '编辑账户' },
          hidden: true,
        },
        {
          path: 'custom',
          name: 'BusinessUserAccountCustom',
          component: () => import('@/views/center-business/user/account/custom'),
          meta: { title: '新建客户', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_RelatedCompany',
          meta: { title: '关联组织架构' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_ChangePassword',
          meta: { title: '修改密码' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_UseStatus',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_Locked',
          meta: { title: '锁定/解锁' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_Delete',
          meta: { title: '删除账户' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserAccountIndex_Log',
          meta: { title: '日志' },
          hidden: true,
        },
      ],
    },

    /**     ****** 角色管理    ******** */
    {
      path: 'role',
      name: 'BusinessUserRole',
      component: EmptyRouter,
      redirect: 'role/list',
      meta: { title: '角色管理', isCache: true },
      children: [
        {
          path: 'list',
          name: 'BusinessUserRole',
          component: () => import('@/views/center-business/user/role/index'),
          meta: { title: '角色管理', isCache: true },
        },
        {
          path: 'allot-account',
          name: 'BusinessUserRoleAllotUser',
          component: () => import('@/views/center-business/user/role/allotUser'),
          meta: { title: '分配用户' },
          hidden: true,
        },
        {
          path: 'allot-data',
          name: 'BusinessUserRoleAllotData',
          component: () => import('@/views/center-business/user/role/allotData'),
          meta: { title: '分配数据权限' },
          hidden: true,
        },
        {
          path: 'allot-menu',
          name: 'BusinessUserRoleAllotMenu',
          component: () => import('@/views/center-business/user/role/allotMenu'),
          meta: { title: '分配菜单权限' },
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessUserRoleIndex_AddRole',
          meta: { title: '创建角色', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserRoleIndex_Edit',
          meta: { title: '编辑角色' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserRoleIndex_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserRoleAllot_Log',
          meta: { title: '日志' },
          hidden: true,
        },
      ],
    },
    {
      path: 'role',
      name: 'BusinessUserRoleAdminCSG',
      component: EmptyRouter,
      redirect: 'role/adminCSGList',
      meta: { title: '角色管理', isCache: true },
      children: [
        {
          path: 'adminCSGList',
          name: 'BusinessUserRoleAdminCSG',
          component: () => import('@/views/center-business/user/csgAdminRole/adminCSGList'),
          meta: { title: '角色管理', isCache: true },
        },
        {
          path: 'allot-accountCSG',
          name: 'BusinessUserRoleAllotUserCSG',
          component: () => import('@/views/center-business/user/role/allotUserCSG'),
          meta: { title: '分配用户' },
          hidden: true,
        },
        {
          path: 'allot-dataCSG',
          name: 'BusinessUserRoleAllotDataCSG',
          component: () => import('@/views/center-business/user/role/allotDataCSG'),
          meta: { title: '分配数据权限' },
          hidden: true,
        },
        {
          path: 'allot-menuCSG',
          name: 'BusinessUserRoleAllotMenuCSG',
          component: () => import('@/views/center-business/user/role/allotMenuCSG'),
          meta: { title: '分配菜单权限' },
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessUserRoleIndex_AddRole',
          meta: { title: '创建角色', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserRoleIndex_Edit',
          meta: { title: '编辑角色' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserRoleIndex_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessUserRoleAllot_Log',
          meta: { title: '日志' },
          hidden: true,
        },
      ],
    },
    {
      path: 'funConfig',
      name: 'BusinessUserfunConfig',
      component: EmptyRouter,
      redirect: 'funConfig/index',
      meta: { title: '客户功能配置', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessUserfunConfig',
          component: () => import('@/views/center-business/user/funConfig/index'),
          meta: { title: '客户功能配置', isCache: true },
        },
        {
          path: 'detail',
          name: 'BusinessUserfunConfigInfo',
          component: () => import('@/views/center-business/user/funConfig/detail'),
          meta: { title: '客户功能配置', isCache: true },
        },
      ],
    },
    {
      path: 'department',
      name: 'BusinessUserDepartment',
      component: EmptyRouter,
      redirect: 'department/index',
      meta: { title: '部门管理', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessUserDepartment',
          component: () => import('@/views/center-business/user/department/index'),
          meta: { title: '部门管理', isCache: true },
        },
      ],
    },
    {
      path: 'staff',
      name: 'BusinessUserStaffManagement',
      component: EmptyRouter,
      redirect: 'staff/index',
      meta: { title: '仓库人工管理', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessUserStaffManagement',
          component: () => import('@/views/center-business/user/staff/index'),
          meta: { title: '仓库人工管理', isCache: true },
        },
      ],
    },
    {
      path: 'Dept',
      name: 'BusinessUserDeptManagement',
      component: EmptyRouter,
      redirect: 'Dept/index',
      meta: { title: '仓库部门管理', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessUserDeptManagement',
          component: () => import('@/views/center-business/user/Dept/index'),
          meta: { title: '仓库部门管理', isCache: true },
        },
      ],
    },
    {
      path: 'position',
      name: 'BusinessUserDepartPosition',
      component: EmptyRouter,
      redirect: 'position/index',
      meta: { title: '岗位管理', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessUserDepartPosition',
          component: () => import('@/views/center-business/user/position/index'),
          meta: { title: '岗位管理', isCache: true },
        },
      ],
    },
  ],
};
